'use strict';

import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';
import Photoswipe from './photoswipe.esm.min.js';

class ZoomAction extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type || 'no_zoom';
    this.zoomOption = this.dataset.zoomOption || 'external';
    this.lightbox = null;
    this.drift = null;
    this.onResponsive = this.responsive.bind(this);
  }
  connectedCallback() {
    if (this.type === 'no_zoom') return;
    window.addEventListener('resize', this.onResponsive);
    window.addEventListener('load', this.onResponsive);
    // Slow unrelated resources and upgrades after load must not block zoom.
    requestAnimationFrame(() => { if (this.isConnected) this.responsive(); });
  }
  initLightBox() {
    if (this.lightbox !== null) return;
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this,
      children: 'a.media-gallery__image',
      pswpModule: () => Photoswipe,
      loop: false,
      bgOpacity: 1,
      showHideAnimationType: 'none',
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      closeTitle: 'Schließen (Esc)',
      zoomTitle: 'Vergrößern / Verkleinern',
      arrowPrevTitle: 'Vorheriges Bild',
      arrowNextTitle: 'Nächstes Bild',
      errorMsg: 'Das Bild konnte nicht geladen werden.',
      imageClickAction: 'zoom',
      tapAction: 'toggle-controls',
      doubleTapAction: 'zoom',
      returnFocus: true,
    });
    this.lightbox.on('bindEvents', () => {
      this.lightbox?.pswp?.element.focus({preventScroll: true});
    });
    this.lightbox.init();
  }
  initDrift() {
    if (this.drift !== null) return;
    const allTriggers = this.querySelectorAll('.drift-trigger');
    const paneContainer = this.closest('.sec__featured-product')?.querySelector('.zoom-external-area');
    allTriggers.forEach((trigger) => {
      const inlineContainer = trigger.closest('[data-pane-container]');
      const zoomOption = this.zoomOption;
      this.drift = new Drift(trigger, {
        inlinePane: zoomOption === 'inner-2' ? true : zoomOption,
        zoomFactor: zoomOption === 'inner-2' ? 3 : 5,
        containInline: !!paneContainer,
        paneContainer: zoomOption === 'external' ? paneContainer : inlineContainer,
        hoverBoundingBox: zoomOption === 'external',
        onShow: () => inlineContainer?.classList.add('relative'),
        onHide: () => inlineContainer?.classList.remove('relative'),
      });
    });
  }
  responsive() {
    if (window.innerWidth < 768 || this.type === 'open_lightbox') {
      if (this.drift !== null) {
        this.drift.destroy();
        this.drift = null;
      }
      this.initLightBox();
    } else {
      if (this.lightbox !== null) {
        this.lightbox.destroy();
        this.lightbox = null;
      }
      this.initDrift();
    }
    this.querySelector('.thumbnail-slide')?.swiper?.update();
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.onResponsive);
    window.removeEventListener('load', this.onResponsive);
    this.lightbox?.destroy();
    this.lightbox = null;
    this.drift?.destroy();
    this.drift = null;
  }
}
customElements.define('zoom-action', ZoomAction);
